import { render } from "./DbsLinkButton.vue?vue&type=template&id=7c8dc552&scoped=true"
import script from "./DbsLinkButton.vue?vue&type=script&lang=js"
export * from "./DbsLinkButton.vue?vue&type=script&lang=js"

import "./DbsLinkButton.vue?vue&type=style&index=0&id=7c8dc552&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c8dc552"

export default script